import reloadTable from './data-loading/reloadTable';
import * as alwaysInCacheTableIdList from './helpers/tableCache/alwaysInCacheTableIdList';
import { listViewStore } from 'owa-mail-list-store';

export default function reloadInboxPostBoot() {
    // Reload Inbox folder after 3 seconds after boot, so that we cover the gap between when SessionData was fetched
    // and when our notification channel gets established.
    setTimeout(() => {
        // The default Inbox table is always added first in alwaysInCacheTableIdList
        const inboxTableId = alwaysInCacheTableIdList.getTableIdAtIndex(0);
        const tableView = listViewStore.tableViews.get(inboxTableId);
        reloadTable(tableView);
    }, 3000);
}
